import { gql } from '@apollo/client'
import { IQueryBasicData, ID } from '../IQueryData'

export interface IStatParkingPoolEmployeeUsageVars {
  parkingPool: ID
  from: string
  to: string
}

export interface IEmployeeUsageRow {
  login: string
  firstName: string | null
  lastName: string | null
  reservedDays: number
  usedDays: number
  cancelledDays: number
}

export interface IStatParkingPoolEmployeeUsageData {
  statParkingPoolEmployeeUsage: IQueryBasicData & {
    stats: IEmployeeUsageRow[] | null
  }
}

export const STAT_PARKING_POOL_EMPLOYEE_USAGE = gql`
  query statParkingPoolEmployeeUsage(
    $parkingPool: ID!
    $from: DateTime!
    $to: DateTime!
  ) {
    statParkingPoolEmployeeUsage(
      parking_pool: $parkingPool
      from: $from
      to: $to
    ) {
      status
      code
      error
      message
      stats {
        login
        firstName: first_name
        lastName: last_name
        reservedDays: reserved_days
        usedDays: used_days
        cancelledDays: cancelled_days
      }
    }
  }
`
